/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Required input.
 *
 *  - DISABLED: The job won't schedule any run if disabled.
 * @export
 */
export const JobMode = {
  UNKNOWN_MODE: 'UNKNOWN_MODE',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;
export type JobMode = (typeof JobMode)[keyof typeof JobMode];

export function instanceOfJobMode(value: any): boolean {
  for (const key in JobMode) {
    if (Object.prototype.hasOwnProperty.call(JobMode, key)) {
      if (JobMode[key as keyof typeof JobMode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function JobModeFromJSON(json: any): JobMode {
  return JobModeFromJSONTyped(json, false);
}

export function JobModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobMode {
  return json as JobMode;
}

export function JobModeToJSON(value?: JobMode | null): any {
  return value as any;
}

export function JobModeToJSONTyped(value: any, ignoreDiscriminator: boolean): JobMode {
  return value as JobMode;
}
